import { Enums } from "utilities/enums";

export const create = (compsToCalc, inputName, optionType) => {
  // const filteredComps = comps.filter(c => c.isSelectedAsComp);
  const priceField = getPriceFieldByInputName(inputName);
  if (compsToCalc.length === 0 || !priceField) {
    return [];
  }
  const values = compsToCalc.reduce((previous, comp) => {
    if (previous.min !== null) {
      if (comp[priceField] < previous.min) {
        previous.min = comp[priceField];
      }
    } else {
      previous.min = comp[priceField];
    }
    if (previous.max !== null) {
      if (comp[priceField] > previous.max) {
        previous.max = comp[priceField];
      }
    } else {
      previous.max = comp[priceField];
    }
    if (previous.total !== null) {
      previous.total += comp[priceField];
    } else {
      previous.total = comp[priceField];
    }
    return previous;
  }, { min: null, max: null, total: null });

  if (values.min != null && values.max != null && values.total != null) {
    return [{ optionType: optionType, label: 'Min Selected Comps', value: values.min, type: getEnumTypeByInputName(inputName)?.CompsMin },
    { optionType: optionType, label: 'Avg Selected Comps', value: parseFloat((values.total / compsToCalc.length).toFixed(0)), type: getEnumTypeByInputName(inputName)?.CompsAvg },
    { optionType: optionType, label: 'Max Selected Comps', value: values.max, type: getEnumTypeByInputName(inputName)?.CompsMax }
      // { value: '1,450', label: 'Avg MSR Comps $' }
    ];
  } else {
    return [];
  }
}

const getEnumTypeByInputName = (inputName) => {
  switch (inputName) {
    case 'rents':
      return Enums.RentType;
    case 'afterRepairValues':
      return Enums.AfterRepairValueType;
    default:
      return null;
  }
}

const getPriceFieldByInputName = (inputName) => {
  switch (inputName) {
    case 'rents':
    case 'afterRepairValues':
      return 'growthAdjustedPrice'; // Use growth adjusted price for both rent and ARV comps
    default:
      return null;
  }
}